import { IReservation, ReservationInventoryItemGroupType } from 'gen/ApiClient';
import { ReservationInventoryItemGroupTypesRecord } from 'shared/records/ReservationInventoryItemGroupTypesRecord';

export const inventoryItemGroupTypesToDisplay = (item: IReservation) => {
    if (item.inventoryItemGroupTypes === null || item.inventoryItemGroupTypes === undefined || item.inventoryItemGroupTypes.length === 0) {
        return "";
    } else {
        return item.inventoryItemGroupTypes.map(t => ReservationInventoryItemGroupTypesRecord[t as ReservationInventoryItemGroupType]).join('; ');
    }
}